// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__3eVxT","perdeu":"LoginForm_perdeu__2p2Hd","cadastro":"LoginForm_cadastro__1t9cC","subtitle":"LoginForm_subtitle__2mvZK"};